module.exports = __webpack_public_path__ + "assets/img/frame-team.35ed3423.png";